export default __webpack_public_path__ + "static/media/Stage5_wrong.9187eb37.svg";